import { useForm } from 'react-hook-form'
import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { Form } from '@/components/ui/form'
import {
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'
import { CallFormFields } from '@/features/chamados/form-fields/call.form-fields'
import { useAuthStore } from '@/features/sessao/store/useAuthStore'
import { Call } from '@/services/backend/config/entities'

import { ChamadoService } from '../../services/chamado.service'

interface Props {
  onSuccess: (data: Call) => void
  onClose: () => void
}

const Component = ({ onSuccess, onClose }: Props) => {
  const { client } = useAuthStore()

  const form = useForm<Parameters<typeof ChamadoService.create>[0]>({
    defaultValues: {
      description: '',
      requesterName: '',
      requesterPhone: '',
      requesterMail: '',
      files: [],
    },
  })

  const onSubmit = form.handleSubmit(async (data) => {
    if (!client) return toast.error('Patrimônio não encontrado')

    try {
      const res = await ChamadoService.create({
        ...data,
        assetId: client.asset.id,
      })
      onSuccess(res)
      onClose()
    } catch {
      // Error toast is already shown by the API connector interceptor
    }
  })

  return (
    <SheetContent className="w-full overflow-y-auto sm:max-w-xl">
      <Form {...form}>
        <form onSubmit={onSubmit} className="flex h-full flex-col">
          <SheetHeader>
            <SheetTitle>Novo chamado</SheetTitle>
          </SheetHeader>

          <div className="flex flex-1 flex-col gap-4 py-4">
            <CallFormFields.RequesterName />
            <CallFormFields.RequesterPhone />
            <CallFormFields.RequesterMail />
            <CallFormFields.Description />
            <CallFormFields.Evidences />
          </div>

          <SheetFooter>
            <Button type="submit">Salvar</Button>
          </SheetFooter>
        </form>
      </Form>
    </SheetContent>
  )
}

export default Component
